import React, { useEffect, useState, useRef } from "react";
import { ButtonBase, DataTableBase } from "@reusejs/react";
import { useRouter } from "next/router";
import { getBidderByUserUuid } from "services";
import { useSelector } from "react-redux";

export default function BidderKycTable() {
  const router = useRouter();

  const user = useSelector((state: any) => {
    return state.bidderAuth.user;
  });

  const [config, setConfig] = useState<any>({
    filterable: false,
    columns: [
      {
        label: "Event Id",
        identifier: "event_id",
        resolver: (d: any) => {
          return d.meta?.event_id ? d.meta?.event_id : "-";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Email",
        identifier: "email",
        resolver: (d: any) => {
          return d.email;
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Verified Document",
        identifier: "verified_doc",
        resolver: (d: any) => {
          return d.kyc_data?.pan_data?.verified
            ? d.kyc_data?.pan_data?.document_type
              ? d.kyc_data?.pan_data?.document_type
              : "Pending"
            : "Pending";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "Other Verified Document",
        identifier: "other_verified_doc",
        resolver: (d: any) => {
          return d.kyc_data?.other_document_data?.verified
            ? d.kyc_data?.other_document_data?.document_type
              ? d.kyc_data?.other_document_data?.document_type
              : "Pending"
            : "Pending";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "KYC Status",
        identifier: "kyc_status",
        resolver: (d: any) => {
          return d.kyc_verified ? "Verified" : "Pending";
        },
        sortable: false,
        filterable: false,
      },
      {
        label: "",
        filterable: false,
        actions: true,
        resolver: (d: any) => {
          // console.log("data in action d:>", d.uuid);
          return (
            <div className="flex justify-center items-center space-x-2">
              <ButtonBase
                variant="primary"
                type="submit"
                label={"View"}
                onClick={() =>
                  router.push(`/kyc/${d.uuid}?step=verification_result`)
                }
                buttonBaseClasses={{
                  font: "text-base font-medium",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  border: "any",
                  width: "w-24",
                  padding: "px-2 py-2",
                }}
              />
            </div>
          );
        },
      },
    ],
  });

  useEffect(() => {
    if (user.uuid) {
      // refresh the table
    }
  }, [user]);

  const dataSource = async (params: any) => {
    let response: any = {};

    if (user?.uuid) {
      response = await getBidderByUserUuid(user.uuid);
    } else {
      response = [];
    }

    let data = response;

    return {
      data: data,
      pagination: {
        total: 0,
      },
    };
  };

  return (
    <div className="w-full p-6 flex flex-col justify-center">
      <div className="min-w-full flex justify-between">
        <div className="w-1/2 text-4xl text-blue-600 font-extrabold dark:text-red-600">
          Your KYC
        </div>
      </div>
      <div className="mt-10">
        <DataTableBase
          sortColumn={0}
          sortOrder={"asc"}
          dataSource={dataSource}
          perPage={10}
          config={config}
        />
      </div>
    </div>
  );
}
